import React from "react";
import { Check } from "lucide-react";

// A faithful-enough WhatsApp bubble so the admin can see exactly what the
// customer will receive — links, line breaks, emoji and all.
const linkify = (text) =>
  text.split(/(\s+)/).map((chunk, i) =>
    /^https?:\/\//.test(chunk)
      ? <a key={i} href={chunk} target="_blank" rel="noreferrer" style={{ color: "#53bdeb", textDecoration: "underline", wordBreak: "break-all" }}>{chunk}</a>
      : <React.Fragment key={i}>{chunk}</React.Fragment>
  );

export const WhatsAppPreview = ({ message, name }) => (
  <div data-testid="wa-preview" style={{
    background: "#0b141a",
    backgroundImage: "radial-gradient(rgba(255,255,255,0.035) 1px, transparent 1px)",
    backgroundSize: "18px 18px",
    borderRadius: "14px",
    border: "1px solid rgba(255,255,255,0.07)",
    padding: "14px 12px 18px",
  }}>
    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px", paddingBottom: "10px", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
      <div style={{ width: "28px", height: "28px", borderRadius: "50%", background: "linear-gradient(135deg,#25d366,#128c7e)", display: "flex", alignItems: "center", justifyContent: "center", color: "#04231a", fontWeight: 800, fontSize: "0.78rem" }}>
        {(name || "C").slice(0, 1).toUpperCase()}
      </div>
      <div>
        <div style={{ color: "rgba(255,255,255,0.88)", fontSize: "0.82rem", fontWeight: 600 }}>{name || "Customer"}</div>
        <div style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.68rem" }}>WhatsApp preview</div>
      </div>
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <div style={{
        maxWidth: "88%", background: "#005c4b", color: "#e9edef", borderRadius: "12px 12px 3px 12px",
        padding: "9px 11px 6px", fontSize: "0.86rem", lineHeight: 1.55, whiteSpace: "pre-wrap",
        boxShadow: "0 1px 2px rgba(0,0,0,0.35)",
      }}>
        {message ? linkify(message) : <span style={{ opacity: 0.45 }}>Your message will appear here…</span>}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "3px", marginTop: "4px" }}>
          <span style={{ color: "rgba(233,237,239,0.55)", fontSize: "0.63rem" }}>
            {new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
          </span>
          <Check size={11} style={{ color: "#53bdeb", marginRight: "-7px" }} />
          <Check size={11} style={{ color: "#53bdeb" }} />
        </div>
      </div>
    </div>
  </div>
);

export default WhatsAppPreview;
